import ReferralDetailPanelContainer from './ReferralDetailPanelContainer';

export default ReferralDetailPanelContainer;
